(function () {
  var COMPACT_CLASS = 'breakout-header-compact';
  var header = document.querySelector('.header.breakout-header');
  var mobileHeader = document.querySelector('.mobile-header.breakout-mobile-header');
  var desktopStickyWrapper = document.querySelector('#header-sticky-wrapper');
  var mobileStickyWrapper = document.querySelector('#mobile-header-sticky-wrapper');
  var headerShell = document.querySelector('.breakout-header__shell');
  var headerNavRow = document.querySelector('.breakout-header__nav-row');
  var headerNav = document.querySelector('.breakout-header__nav');
  var themeMobileQuery = window.matchMedia('(max-width: 798px)');
  var desktopNavQuery = window.matchMedia('(min-width: 1024px)');
  var isHome = document.body.classList.contains('index') || !!document.getElementById('template-index');
  var logoLightSrc = document.querySelector('[data-breakout-logo-light]')?.getAttribute('data-breakout-logo-light');
  var logoDarkSrc = document.querySelector('[data-breakout-logo-dark]')?.getAttribute('data-breakout-logo-dark');
  var compactActive = false;
  var mobileMenuActive = false;
  var measuredNavWidth = 0;
  var compactCheckTimer;
  var COMPACT_ENTER_BUFFER = 12;
  var COMPACT_EXIT_BUFFER = 48;

  function getAvailableNavWidth() {
    if (headerNavRow && headerNavRow.clientWidth > 0) {
      return headerNavRow.clientWidth;
    }

    if (headerShell && headerShell.clientWidth > 0) {
      return headerShell.clientWidth;
    }

    return window.innerWidth;
  }

  function isDesktopNavHidden() {
    if (!headerNav) return false;

    var navStyle = window.getComputedStyle(headerNav);
    return navStyle.display === 'none' || navStyle.visibility === 'hidden';
  }

  function isStickyActive() {
    return (
      (desktopStickyWrapper && desktopStickyWrapper.classList.contains('is-sticky')) ||
      (mobileStickyWrapper && mobileStickyWrapper.classList.contains('is-sticky'))
    );
  }

  function setLogoVariant(useColorLogo) {
    document.querySelectorAll('.breakout-header__logo-img').forEach(function (img) {
      if (!logoLightSrc || !logoDarkSrc) return;
      img.src = useColorLogo ? logoDarkSrc : logoLightSrc;
    });
  }

  function isMobileHeaderActive() {
    return themeMobileQuery.matches || compactActive;
  }

  function updateHeaderState() {
    var scrolled = window.scrollY > 16;
    var solidBar = isHome && (scrolled || isStickyActive());
    var overHero = isHome && !solidBar;

    if (header) {
      header.classList.toggle('breakout-header--scrolled', solidBar);
      header.classList.toggle('breakout-header--over-hero', overHero);
    }

    if (mobileHeader) {
      mobileHeader.classList.toggle('breakout-header--scrolled', solidBar);
      mobileHeader.classList.toggle('breakout-header--over-hero', overHero);
    }

    if (isHome) {
      setLogoVariant(solidBar || isMobileHeaderActive());
    } else if (isMobileHeaderActive()) {
      setLogoVariant(true);
    }
  }

  function headerContentOverflows() {
    if (!headerNavRow || !headerNav || !header) return false;
    if (themeMobileQuery.matches || desktopNavQuery.matches) return false;

    var navList = headerNav.querySelector('.breakout-nav');
    if (!navList) return false;

    if (!isDesktopNavHidden()) {
      measuredNavWidth = navList.scrollWidth;

      if (compactActive) {
        return navList.scrollWidth > headerNavRow.clientWidth - COMPACT_EXIT_BUFFER;
      }

      return navList.scrollWidth > headerNavRow.clientWidth + COMPACT_ENTER_BUFFER;
    }

    if (measuredNavWidth <= 0) {
      return compactActive;
    }

    var availableWidth = getAvailableNavWidth();

    if (compactActive) {
      return measuredNavWidth > availableWidth - COMPACT_EXIT_BUFFER;
    }

    return measuredNavWidth > availableWidth + COMPACT_ENTER_BUFFER;
  }

  function syncHeaderMode() {
    if (typeof window.jQuery === 'undefined' || !window.Shopify || !Shopify.theme) return;

    var useMobileMenu = themeMobileQuery.matches || compactActive;

    if (useMobileMenu) {
      if (!mobileMenuActive && Shopify.theme.mobileMenu) {
        if (Shopify.theme.jsHeader && typeof Shopify.theme.jsHeader.disableSticky === 'function') {
          Shopify.theme.jsHeader.disableSticky();
        }
        Shopify.theme.mobileMenu.init();
        mobileMenuActive = true;
      }
      return;
    }

    if (mobileMenuActive && Shopify.theme.mobileMenu) {
      Shopify.theme.mobileMenu.unload();
      mobileMenuActive = false;

      if (
        Shopify.theme.jsHeader &&
        Shopify.theme.jsHeader.enable_sticky === true &&
        typeof window.isScreenSizeLarge === 'function' &&
        window.isScreenSizeLarge() &&
        typeof Shopify.theme.jsHeader.enableSticky === 'function'
      ) {
        var announcementHeight = window.jQuery('.announcement-sticky-wrapper').height() || 0;
        Shopify.theme.jsHeader.enableSticky(announcementHeight);
      }
    }
  }

  function updateCompactHeader() {
    if (desktopNavQuery.matches) {
      if (compactActive) {
        compactActive = false;
        measuredNavWidth = 0;
        document.documentElement.classList.remove(COMPACT_CLASS);
        syncHeaderMode();
      }

      updateHeaderState();
      return;
    }

    // Below the 1024px desktop breakpoint the primary nav is hidden via CSS, so
    // the tablet range (799px–1023px) must always fall back to the hamburger
    // header. Measuring the nav width here is unreliable because the nav is
    // display:none at these widths and reports a width of 0 ("always fits").
    var shouldCompact = !themeMobileQuery.matches;

    if (shouldCompact !== compactActive) {
      compactActive = shouldCompact;
      document.documentElement.classList.toggle(COMPACT_CLASS, shouldCompact);
      syncHeaderMode();
    }

    updateHeaderState();
  }

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });

  if (desktopStickyWrapper) {
    new MutationObserver(updateHeaderState).observe(desktopStickyWrapper, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (mobileStickyWrapper) {
    new MutationObserver(updateHeaderState).observe(mobileStickyWrapper, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function scheduleCompactCheck() {
    window.clearTimeout(compactCheckTimer);
    compactCheckTimer = window.setTimeout(function () {
      window.requestAnimationFrame(updateCompactHeader);
    }, 120);
  }

  window.addEventListener('resize', scheduleCompactCheck, { passive: true });
  themeMobileQuery.addEventListener('change', function () {
    compactActive = false;
    measuredNavWidth = 0;
    document.documentElement.classList.remove(COMPACT_CLASS);
    syncHeaderMode();
    scheduleCompactCheck();
  });

  desktopNavQuery.addEventListener('change', function () {
    compactActive = false;
    measuredNavWidth = 0;
    document.documentElement.classList.remove(COMPACT_CLASS);
    syncHeaderMode();
    scheduleCompactCheck();
  });

  if (headerShell && typeof ResizeObserver !== 'undefined') {
    var resizeObserver = new ResizeObserver(scheduleCompactCheck);
    resizeObserver.observe(headerShell);

    if (headerNavRow) {
      resizeObserver.observe(headerNavRow);
    }

    if (headerNav) {
      resizeObserver.observe(headerNav);
    }
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleCompactCheck);
  }

  window.addEventListener('load', scheduleCompactCheck);
  scheduleCompactCheck();

  window.setTimeout(scheduleCompactCheck, 250);
  window.setTimeout(scheduleCompactCheck, 800);

  (function waitForThemeHeader(attempts) {
    if (window.Shopify && Shopify.theme && Shopify.theme.jsHeader && Shopify.theme.mobileMenu) {
      scheduleCompactCheck();
      return;
    }
    if (attempts > 40) return;
    window.setTimeout(function () {
      waitForThemeHeader(attempts + 1);
    }, 50);
  })(0);
})();

/* Desktop nav dropdowns.
   Each .breakout-nav__item--dropdown is position:relative, so its panel opens
   directly below its own trigger's row — even when the links wrap onto a second
   row on smaller desktops (an open first-row panel simply covers the row below,
   so nothing can steal the hover). Because the item is the containing block for
   BOTH axes, the panel's left/width are corrected here per item so it still
   spans the full .breakout-nav width.
   Open state is driven via .is-open: open and switch are instant (as the pure
   :hover behaviour was); a short close grace lets the cursor cross the 4px gap
   between the trigger and the panel. CSS keeps a :hover fallback when this
   script hasn't run (gated on html.breakout-nav-js) and :focus-within for
   keyboard users. */
(function () {
  var CLOSE_DELAY = 200;

  var nav = document.querySelector('.breakout-nav');
  var items = Array.prototype.slice.call(
    document.querySelectorAll('.breakout-nav__item--dropdown')
  );
  if (!nav || !items.length) return;

  document.documentElement.classList.add('breakout-nav-js');

  function positionDropdowns() {
    var navRect = nav.getBoundingClientRect();
    if (!navRect.width) return;
    items.forEach(function (item) {
      var dropdown = item.querySelector('.breakout-nav__dropdown');
      if (!dropdown) return;
      var itemRect = item.getBoundingClientRect();
      dropdown.style.left = navRect.left - itemRect.left + 'px';
      dropdown.style.width = navRect.width + 'px';
      /* the base .breakout-nav__dropdown rule's translateX(-50%) outranks the
         mega rule's transform:none in the cascade — neutralize it inline */
      dropdown.style.transform = 'none';
    });
  }

  var positionTimer;
  function schedulePosition() {
    window.clearTimeout(positionTimer);
    positionTimer = window.setTimeout(positionDropdowns, 100);
  }

  window.addEventListener('resize', schedulePosition, { passive: true });
  window.addEventListener('load', positionDropdowns);
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(positionDropdowns);
  }
  positionDropdowns();

  var openItem = null;
  var closeTimer = null;

  function setOpen(item) {
    if (openItem === item) return;
    if (openItem) openItem.classList.remove('is-open');
    openItem = item;
    if (item) item.classList.add('is-open');
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      setOpen(item);
    });

    item.addEventListener('mouseleave', function () {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        setOpen(null);
      }, CLOSE_DELAY);
    });
  });
})();
